import { useSelector } from "react-redux"
import { RoomType } from "../../../App/enums"
import { capitalizeFirstLetter } from "../../../App/Helpers/Helpers"
import { selectTranslations } from "../../../App/i18n/i18nSlice"
import "../../../Styles/main.scss"
import Image from "../../Shared/Primitive/Image"

function ProfileRoomsItem(props: {
    onClick: () => void
    isLastItem: boolean
    image: string
    firstText: string
    type: string
    secondText?: string
    members: string
    date: string
}) {
    const translation = useSelector(selectTranslations)

    return (
        <div onClick={props.onClick} className={`profile-rooms-item ${props.isLastItem && "profile-rooms-item--border-none"}`}>
            <div className="profile-rooms-item__image">
                <Image className="image image__profile image__profile--fit image__profile--size-small" src={props.image} alt="Organization" />
            </div>
            <div className="profile-rooms-item__organization-name">
                <p><span className="profile-rooms-item__organization-name--text">{props.secondText}</span><br/>
                <span>{props.firstText}</span></p>
            </div>
            <div className="profile-rooms-item__type">
                <div
                    className={`profile-rooms-item__type-container profile-rooms-item__type-container--${
                        props.type === translation.private ? capitalizeFirstLetter(RoomType.Private) : capitalizeFirstLetter(RoomType.Public)
                    }`}
                >
                    <div className="profile-rooms-item__text ">{props.type}</div>
                </div>
            </div>
            <div className="profile-rooms-item__members">
                <div className="profile-rooms-item__members-container">
                    <div className="profile-rooms-item__text">
                        {props.members} {props.members === "1" ? translation.member : translation.members}
                    </div>
                </div>
            </div>
            <div className="profile-rooms-item__date">{props.date}</div>
        </div>
    )
}

export default ProfileRoomsItem
